import styled from 'styled-components';
import { Divider } from 'antd';

export const StyledDivider = styled(Divider)`
    margin: 0;
    border-top: 2px solid ${({ theme }) => theme.color.certnGray200} !important;
`;
